import { render, staticRenderFns } from "./DummyCounter.vue?vue&type=template&id=3c18805f&scoped=true&"
import script from "./DummyCounter.vue?vue&type=script&lang=ts&"
export * from "./DummyCounter.vue?vue&type=script&lang=ts&"
import style0 from "./DummyCounter.vue?vue&type=style&index=0&id=3c18805f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c18805f",
  null
  
)

export default component.exports